import React from 'react'
import { Card, IconWrapper, AccessIcon, CardTextWrapper, AccessGrid } from './styled'
import { Text2 } from '../text'
import theme from '../../../styled/theme'

const Cards = ({ list, iconColor, onClick, mobileColumns, fullMobileCard, roundedIcon }) => {
	return (
		<AccessGrid mobileColumns={mobileColumns}>
			{list.map(item => {
				const IconComponent = item.Icon
				return (
					<Card
						onClick={() => onClick(item.routes)}
						$fullMobileCard={fullMobileCard}
						$rounded={roundedIcon}
					>
						<IconWrapper
							size={roundedIcon ? 48 : 24}
							$fullMobileCard={fullMobileCard}
							$rounded={roundedIcon}
						>
							<AccessIcon $rounded={roundedIcon}>
								<IconComponent color={iconColor} size={24} width={24} height={24} />
							</AccessIcon>
						</IconWrapper>
						<CardTextWrapper>
							<Text2
								size="16px"
								mobileSize="14px"
								fontWeight={roundedIcon ? 600 : 500}
								align="center"
								color={theme.colors.text.primaryText}
							>
								{item.title}
							</Text2>
							{item.subtitle && (
								<Text2
									size="14px"
									mobileSize="12px"
									align="center"
									color={theme.colors.text.secondaryText}
								>
									{item.subtitle}
								</Text2>
							)}
						</CardTextWrapper>
					</Card>
				)
			})}
		</AccessGrid>
	)
}

export default Cards